var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',_vm._b({attrs:{"inline":_vm.inline,"dot":_vm.dot,"color":_vm.color}},'v-badge',_vm.$attrs,false),[_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }